import { render } from "./RfpCategories.vue?vue&type=template&id=7672e781&ts=true"
import script from "./RfpCategories.vue?vue&type=script&lang=ts"
export * from "./RfpCategories.vue?vue&type=script&lang=ts"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__